import {Component, input} from '@angular/core';

@Component({
  selector: 'elcia-dot',
  imports: [],
  templateUrl: './dot.html',
  styleUrl: './dot.scss',
  host: {class: 'inline-flex'},
})
export class Dot {
  color = input.required<string>();
}
